class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/delegators`;
    }
    /**
     * Returns the list of users who can delegate bridge/meeting creation to the given user.
     * HTTP Method: get
     * Endpoint: /rcvideo/v1/accounts/{accountId}/extensions/{extensionId}/delegators
     * Rate Limit Group: Medium
     * App Permission: Video
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
